export const BG_PRIMARY = '#b4c5d5';
export const BG_SECONDARY = '#fff';
export const BG_ALTERNATIVE = '#636466a1';
export const BG_OPACITY = 'rgb(153, 170, 182)';

export const TEXT_PRIMARY = '#fff';
export const TEXT_SECONDARY = '#67544e';
export const TEXT_ALTERNATIVE = '#fff';

export const BG_NAVIGATION = '#9b7065';
export const ICON_NAVIGATION = '#FFF';

export const DEFAULT_BUTTON_PROPS = '';
